'use client'

import { Children, useEffect, useState, type ReactNode } from 'react'
import { useLoader } from '@/components/LoaderContext'

const DELAY_MS = 120

export default function StaggeredFadeSections({ children }: { children: ReactNode }) {
  const { isLoaderActive } = useLoader()
  const [startFadeIn, setStartFadeIn] = useState(false)

  // Start staggered fade-in only after the intro loader is done so the user sees it
  useEffect(() => {
    if (isLoaderActive) return
    const id = requestAnimationFrame(() => {
      setStartFadeIn(true)
    })
    return () => cancelAnimationFrame(id)
  }, [isLoaderActive])

  return (
    <>
      {Children.map(children, (child, i) => {
        // First section (About / UX Engineer): no fade animation to avoid glitch; show when loader done
        const isFirst = i === 0
        return (
          <div
            className={
              isFirst
                ? undefined
                : startFadeIn
                  ? 'animate-fade-in-section'
                  : 'opacity-0'
            }
            style={
              !isFirst && startFadeIn
                ? ({
                    animationDelay: `${(i - 1) * DELAY_MS}ms`,
                    animationFillMode: 'both',
                  } as React.CSSProperties)
                : undefined
            }
          >
            {child}
          </div>
        )
      })}
    </>
  )
}
